/*
 * @description：静态数据 统一维护
 */

import { getChannelResourceCode } from './channel';
import cookies from './cookie';
export const CDN_PREFIX = 'https://cdn-qcloud.zhongan.com/a00000/za-asclepius/';
export const STATIC_CDN_PREFIX = 'https://static.za-doctor.com/';
export const _Data_To_Obj = (array: any[] = []) => {
  const obj = {};
  array.map((k) => {
    obj[k.value] = k.label;
    return k;
  });
  return obj;
};

export const createArray = (length: number, unit: string) =>
  Array.from({ length }, (x, v) => ({
    label: `${v + 1}${unit}`,
    value: `${v + 1}`,
  }));

// 科室选择页面 下拉排序菜单
export const ORDER_MENU = [
  { label: '默认排序', value: 'default' },
  { label: '咨询量由高到低', value: 'INQUIRY_NUM_DESC' },
  { label: '好评量由高到低', value: 'HIGH_OPINION_RATE' },
  { label: '价格由高到低', value: 'INQUIRY_PRICE_DESC' },
  { label: '价格由低到高', value: 'INQUIRY_PRICE' },
];

export const ORDER_MENU_OBJ = _Data_To_Obj(ORDER_MENU);

/** ********** 问诊单状态 ************/
export const INQUIRY_TAB_STATUS = [
  { label: '全部', value: 0 },
  { label: '待付款', value: 1 },
  { label: '待接诊', value: 2 },
  { label: '问诊中', value: 3 },
  { label: '已完成', value: 4 },
  { label: '已评价', value: 5 },
  { label: '已退款', value: 6 },
  { label: '已取消', value: 9 },
];

export const INQUIRY_STATUS = [
  { label: '全部', value: 0 },
  { label: '待付款', value: 1 },
  { label: '待接诊', value: 2 },
  { label: '问诊中', value: 3 },
  { label: '已完成', value: 4 },
  { label: '已评价', value: 5 },
  { label: '已退款', value: 6 },
  { label: '待接诊', value: 7 },
  { label: '待分配', value: 8 },
  { label: '已取消', value: 9 },
];

/**
 * @description 问诊单状态
 * - INQUIRY_UNPAID: 待付款 - 1
 * - INQUIRY_AWAIT: 待接诊 - 2
 * - INQUIRY_ING: 问诊中 - 3
 * - INQUIRY_END: 已完成 - 4
 * - INQUIRY_EVALUATED: 已评价 - 5
 * - INQUIRY_REFUND: 已退款 - 6
 * - INQUIRY_UNAUTH: 待授权 - 7
 * - INQUIRY_WAIT_ASSIGN: 待分配 - 8
 * - CANCEL: 已取消 - 9
 */
export enum InquiryStatus {
  /** 待付款 */
  INQUIRY_UNPAID = 1,
  /** 待接诊 */
  INQUIRY_AWAIT = 2,
  /** 问诊中 */
  INQUIRY_ING = 3,
  /** 已完成 */
  INQUIRY_END = 4,
  /** 已评价 */
  INQUIRY_EVALUATED = 5,
  /** 已退款 */
  INQUIRY_REFUND = 6,
  /** 待授权 */
  INQUIRY_UNAUTH = 7,
  /** 待分配 */
  INQUIRY_WAIT_ASSIGN = 8,
  /** 已取消 */
  CANCEL = 9,
}

/**
 * @description 根据问诊单状态返回唯一标识字符串
 * @param {InquiryStatus} status 问诊单状态
 * @returns {string} 状态对应的标识字符串
 */
export const getInquiryStatusIdentifier = (status: InquiryStatus): string => {
  switch (status) {
  case InquiryStatus.INQUIRY_UNPAID:
    return 'unpaid';
  case InquiryStatus.INQUIRY_AWAIT:
    return 'await';
  case InquiryStatus.INQUIRY_ING:
    return 'processing';
  case InquiryStatus.INQUIRY_END:
    return 'completed';
  case InquiryStatus.INQUIRY_EVALUATED:
    return 'evaluated';
  case InquiryStatus.INQUIRY_REFUND:
    return 'refunded';
  case InquiryStatus.INQUIRY_UNAUTH:
    return 'unauthorized';
  case InquiryStatus.INQUIRY_WAIT_ASSIGN:
    return 'waiting_assignment';
  case InquiryStatus.CANCEL:
    return 'cancelled';
  default:
    return 'unknown';
  }
};

/**
 * @description 处方状态枚举
 *
 * - 1 - USABLE     - 可使用：处方已开具且可以使用
 * - 2 - USED       - 已使用：处方已被患者成功使用
 * - 3 - VOIDED     - 已作废：处方因各种原因被标记为无效
 * - 4 - PAYING     - 支付中：处方相关费用正在支付过程中
 * - 5 - REVIEWING  - 审核中：处方正在由药师或相关人员进行审核
 * - 6 - INCOMPLETE - 待补全：处方信息不完整，需要补充
 * - 7 - REVIEW_FAILED   - 审核不通过：处方未通过药师或相关人员的审核
 * - 8 - DOCTOR_REFUSED    - 医生拒绝：医生因专业判断拒绝开具处方
 * - 9 - EXPIRED    - 已失效：处方超过有效期或其他原因导致失效
 */
export enum PrescriptionStatus {
  /** 可使用 */
  USABLE = 1,
  /** 已使用 */
  USED = 2,
  /** 已作废 */
  INVALID = 3,
  /** 支付中 */
  PAYING = 4,
  /** 审核中 */
  REVIEWING = 5,
  /** 待补全 */
  INCOMPLETE = 6,
  /** 审核不通过 */
  REVIEW_FAILED = 7,
  /** 医生拒绝了处方 */
  DOCTOR_REFUSED = 8,
  /** 已失效 */
  EXPIRED = 9,
}

/**
 * @description 根据处方单状态返回唯一标识字符串
 * @param {PrescriptionStatus} status 处方单状态
 * @returns {string} 状态对应的标识字符串
 */
export const getPrescriptionStatusIdentifier = (status: PrescriptionStatus): string => {
  switch (status) {
  case PrescriptionStatus.USABLE:
    return 'usable';
  case PrescriptionStatus.USED:
    return 'used';
  case PrescriptionStatus.INVALID:
    return 'invalid';
  case PrescriptionStatus.PAYING:
    return 'paying';
  case PrescriptionStatus.REVIEWING:
    return 'reviewing';
  case PrescriptionStatus.INCOMPLETE:
    return 'incomplete';
  case PrescriptionStatus.REVIEW_FAILED:
    return 'review_failed';
  case PrescriptionStatus.DOCTOR_REFUSED:
    return 'doctor_refused';
  case PrescriptionStatus.EXPIRED:
    return 'expired';
  default:
    return 'unknown';
  }
};

export const INQUIRY_STATUS_OBJ = _Data_To_Obj(INQUIRY_STATUS);

/** ********** 处方单状态 ************/
export const PRESCRIPTION_STATUS = [
  { label: '全部', value: 0 },
  { label: '可使用', value: 1 },
  { label: '已使用', value: 2 },
  { label: '已作废', value: 3 },
  { label: '已过期', value: 9 },
];

// 处方单icon映射
export const PRESCRIPTION_STATUS_IMG = {
  1: 'enable',
  2: 'used',
  3: 'abolish',
  9: 'disabled',
};

export const PRESCRIPTION_STATUS_OBJ = _Data_To_Obj(PRESCRIPTION_STATUS);

/** ********** 订单状态 ************/
export const ORDER_STATUS_TAB = [
  { value: 0, label: '全部' },
  {
    label: '待付款',
    value: 1,
  },
  {
    label: '待发货',
    value: 5,
  },
  {
    label: '已发货',
    value: 6,
  },
  {
    label: '已完成',
    value: 7,
  },
  {
    label: '已取消',
    value: 99,
  },
];
export const ORDER_STATUS = [
  { value: 0, label: '全部' },
  { value: 1, label: '待付款' },
  { value: 2, label: '支付失败' },
  { value: 3, label: '审核中' },
  { value: 4, label: '审核失败' },
  { value: 5, label: '待发货' },
  { value: 6, label: '已发货' },
  { value: 7, label: '已完成' },
  { value: 8, label: '已退款' },
  { value: 9, label: '支付中' },
  { value: 10, label: '已开票' },
  { value: 11, label: '已预约' },
  { value: 99, label: '已取消' },
];

/**
 * @description 订单状态枚举
 * - 1 - UNPAID: 待付款
 * - 5 - WAIT_DELIVERY: 待发货
 * - 6 - DELIVERED: 已发货
 * - 7 - COMPLETED: 已完成
 * - 8 - REFUNDED: 已退款
 * - 9 - PAYING: 支付中
 * - 10 - TICKETED: 已开票
 * - 11 - RESERVED: 已预约
 * - 99 - CANCELLED: 已取消
 */
export enum ORDER_STATUS_ENUM {
  /** 待付款 */
  UNPAID = 1,
  /** 待发货 */
  WAIT_DELIVERY = 5,
  /** 已发货 */
  DELIVERED = 6,
  /** 已完成 */
  COMPLETED = 7,
  /** 已退款 */
  REFUNDED = 8,
  /** 支付中 */
  PAYING = 9,
  /** 已开票 */
  TICKETED = 10,
  /** 已预约 */
  RESERVED = 11,
  /** 已取消 */
  CANCELLED = 99,
}

/** ********** 退款状态 ************/
export const REFUND_STATUS = [
  { value: 1, label: '退款中' },
  { value: 2, label: '退款成功' },
  { value: 3, label: '退款失败' },
  { value: 4, label: '退款申请失败' },
];

export const ORDER_STATUS_OBJ = _Data_To_Obj(ORDER_STATUS);

export const REFUND_STATUS_OBJ = _Data_To_Obj(REFUND_STATUS);

// /************ 权益 ************/
export const RIGHT_OBJ = {
  // ohClinic: {
  //   text: '互联网门急诊',
  //   img: require('../pages/home/images/a.png'),
  //   path: '/hospital/outpatient',
  // },
  // advancedPayment: {
  //   text: '医疗垫付',
  //   img: require('../pages/home/images/b.png'),
  //   path: '/hospital/unique/medical',
  // },
  // tumourSpecialMedicine: {
  //   text: '肿瘤特药',
  //   img: require('../pages/home/images/c.png'),
  //   path: '/hospital/unique/tumour',
  // },
  // greenChannel: {
  //   text: '重疾绿通',
  //   img: require('../pages/home/images/d.png'),
  //   path: '/hospital/unique/illness',
  // },
  // proton: {
  //   text: '质子重离子',
  //   img: require('../pages/home/images/e.png'),
  //   path: '/hospital/unique/heavyion',
  // },
  // homePostoperativeCare: {
  //   text: '术后家庭护理',
  //   img: require('../pages/home/images/f.png'),
  //   path: '/hospital/unique/nursing',
  // },
  // onlineConsult: {
  //   text: '免费图文问诊',
  //   img: require('../pages/home/images/g.png'),
  //   path: '/hospital/myservpack',
  // },
  // drugDiscount: {
  //   text: '购药优惠',
  //   img: require('../pages/home/images/h.png'),
  //   path: '/hospital/myservpack',
  // },
  // mentalRelease: {
  //   text: '心理倾诉',
  //   img: require('../pages/home/images/i.png'),
  //   path: 'https://m.ydl.com/fxl/listen/activity/za?n_cps_channel_p=B.11.1416.1417.18092728'
  // },
};
/** ********** 订单 ************/

/** ********** 下拉加载的状态枚举 ************/
export const LOAD_STATE = {
  normal: 0, // 普通
  abort: 1, // 中止
  loading: 2, // 加载中
  success: 3, // 加载成功
  failure: 4, // 加载失败
  complete: 5, // 加载完成（无新数据）
};

export const LANGUAGE_DATA = [
  { value: 'zh_CN', label: '普通话' },
  { value: 'en_US', label: '英语' },
];

export const LANGUAGE_OBJ = _Data_To_Obj(LANGUAGE_DATA);

// 心理咨询跳转地址
export const ydlUrl = '/hospital/mentalTalking'; // 改为跳自己的一级页面

// 下拉刷新的状态值
export const REFRESH_STATE = {
  normal: 0, // 普通
  pull: 1, // 下拉刷新（未满足刷新条件）
  drop: 2, // 释放立即刷新（满足刷新条件）
  loading: 3, // 加载中
  success: 4, // 加载成功
  failure: 5, // 加载失败
};

// 问诊页其他信息格式定义
export const INQURIY_OTHER_EXTRAINFO = {
  liverSick: '',
  drugAllergic: {
    class: '您是否有对药物过敏',
    tags: [],
    additional: '',
    placeholder: '请补充您的药物过敏',
    key: '您是否有对药物过敏',
    value: '',
  },
  patientFamilyHistory: {
    healthClass: '您是否有遗传病史',
    class: '您是否有家族病史',
    tags: [],
    additional: '',
    placeholder: '请补充您的遗传病史',
    key: '您是否有家族病史',
    value: '',
  },
};

/* 蚂蚁门急诊资源位 ，针对蚂蚁门急诊有特殊的处理逻辑 ,业务逻辑内判断时，统一引用此变量*/
export const ALI_ER_WHITELIST = ['ANT_INS_OUTPATIENT_CLAIM'];
export const isFromAliER = (channelResourceCode = '') =>
  ALI_ER_WHITELIST.includes(channelResourceCode || getChannelResourceCode() || '');

/* 顺丰 */
export const SF_WHITELIST = ['SFGHGZH', 'SFGHFWDT'];
export const isFromSF = (channelResourceCode = '') =>
  SF_WHITELIST.includes(channelResourceCode || getChannelResourceCode() || '');

/* 菜鸟 */
export const CAINIAO_WHITELIST = ['CNWZFW-AL'];
export const isFromCAINIAO = (channelResourceCode = '') =>
  CAINIAO_WHITELIST.includes(channelResourceCode || getChannelResourceCode() || '');

/* 阿里非菜鸟 */
export const AliNOCAINIAO_WHITELIST = ['ALCGTXFW-BHCN'];
export const isFromAliNOCAINIAO = (channelResourceCode = '') =>
  AliNOCAINIAO_WHITELIST.includes(channelResourceCode || getChannelResourceCode() || '');

// 屏蔽流程的黑名单用户
export const BLACKLIST = ['DmcsOs+mZBpa5bm5mBKmoA=='];
export const isInBlackList = () => {
  const maskActId = cookies.get('maskActId') || '';
  return BLACKLIST.includes(maskActId);
};

/** 华为钱包资源位， 针对华为钱包有特殊的页面渲染逻辑或业务逻辑的时候，统一引用此变量 */
export const HUAWEIQIANBAO_SOURCECODE = ['HWQB'];
export const isFromHuaweiQianbao = (channelResourceCode = '') =>
  HUAWEIQIANBAO_SOURCECODE.includes(channelResourceCode || getChannelResourceCode() || '');

interface thirdPlatformOption {
  [key: string]: string;
}
/* 第三方对接的来源标识 统一管理*/
export const THIRD_PLATFORM_RESOURCECODE: thirdPlatformOption = {
  ZAHY: 'ZA', // 众安互医 、在药品订单内 platformCode = ZA 表示 开药方为国药
  MBJK: 'MB', // 妙保 健康
  LHYW: 'UMP', // UMP联合医务
  SYY_DRUGSTROE: 'SYY', // 上药云药房
  SYY_MB: 'SYYMB', // 上药云药房 - 慢病
  SYYMB_NEW: 'SYYMB_NEW', // 上药云药房 - 慢病
  MB_NEW: 'MB_NEW', // 上药云药房 - 慢病
  SYY_XB: 'SYYXB', // 上药云药房 - 小病0元治
  SYY_YWY: 'SYYYWY', // 上药云药房 - 药无忧
  SYY_YYX: 'SYYYYX', // 上药云药房 - 云药箱
  SYY_SPHCHINA: 'SPHCHINA', // 上药云药房 - 问诊开药
  GJSC: 'GJ', // 高济商城
  XLZY: 'XL', // 小鹿中医
  SSPS_PET: 'HCB', // 山水鹏狮 荟宠宝
  YDL_MENTALRELEASE: 'YDL', // 壹点灵 心理倾诉
  YDL_HEARTASSESS: 'YDL_HEARTASSESS', // 壹点灵 心理测评
  GLZ_VACCINE: 'GLZ', // 橄榄枝健康疫苗
  WEIYI_SERVICE: 'WEIYI', // 微医预约挂号服务
  UNION_DRUG: 'UNION_DRUG', // 药联
  KYUSHU_POP: 'POP', // 九州通
  ZA_MALL: 'ZA_MALL', // 众安生命药品商城
  ZA_HAOYAOSHI: 'ZA_HAOYAOSHI',
  SZ: 'SZ', // 善诊
  JZ_JY: 'JZ_JY', // 洁众
  ZA_UMBRELLA: 'ZA_UMBRELLA', // 方伞健康
  MJ: 'MJ', // 方伞健康
  XIAOFIVE_HEALTH: 'XIAOFIVE_HEALTH',
  ASCLEPIUS_SELF_DRUG: 'ASCLEPIUS_SELF_DRUG',
  BAIHETANG: 'BAIHETANG',
  YIFENG: 'YIFENG', // 益丰
  MNTJ: 'MNTJ',
  SANGGUO: 'SANGGUO',
  YIYH: 'YIYH', // 颐养荟
  LEYA: 'LEYA',
  HY_MALL: 'HY_MALL', // 互医商城
  RJ: 'RJ', // 仁济
  ZAKJ: 'ZAKJ', // 如眠
  CHONGTAI: 'CHONGTAI', // 憧泰
  WEI_FAN: 'WEI_FAN', // 憧泰
  HY_MALL_DEPOSIT: 'HY_MALL_DEPOSIT', // 互医商城车险药诊卡
};

const THIRD_PLATFORM_KEYS: thirdPlatformOption = (() => {
  /*
    把 THIRD_PLATFORM_RESOURCECODE 的key 转换出来，用在  THIRD_PARTNER_AUTH_CONFIG，
    在使用时 取值方式与 THIRD_PLATFORM_RESOURCECODE.ZAHY保持一致
    如：THIRD_PARTNER_AUTH_CONFIG.ZAHY ,省去映射关系
  */
  const keyList = Object.keys(THIRD_PLATFORM_RESOURCECODE);
  return keyList.reduce((prevObj, cur) => {
    prevObj[cur] = cur;
    return prevObj;
  }, {});
})();

interface thirdPartnerAuthOption {
  [key: string]: {
    partnerCode: string;
    businessType: string;
    thirdBizType?: string;
  };
}
/* 第三方合作伙伴授权 统一配置 */
export const THIRD_PARTNER_AUTH_CONFIG: thirdPartnerAuthOption = {
  // 小鹿中医授权
  [THIRD_PLATFORM_KEYS.XLZY]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.XLZY,
    businessType: 'index',
  },

  // 橄榄枝疫苗授权
  [THIRD_PLATFORM_KEYS.GLZ_VACCINE]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.GLZ_VACCINE,
    businessType: 'index',
  },

  // 微医预约挂号授权
  [THIRD_PLATFORM_KEYS.WEIYI_SERVICE]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.WEIYI_SERVICE,
    businessType: 'register',
  },

  // 微医预约挂号 - 个人中心_挂号订单列表页 授权
  [`${THIRD_PLATFORM_KEYS.WEIYI_SERVICE}_LIST`]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.WEIYI_SERVICE,
    businessType: 'list',
  },

  // 荟宠宝 授权
  [THIRD_PLATFORM_KEYS.SSPS_PET]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SSPS_PET,
    businessType: 'regster',
  },

  // 上药云药房 授权 上药云授权partnerCode 统一
  [THIRD_PLATFORM_KEYS.SYY_DRUGSTROE]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SYY_DRUGSTROE,
    businessType: 'partner',
    thirdBizType: 'PY',
  },

  // 上药云慢病 授权 上药云授权 partnerCode 统一
  [THIRD_PLATFORM_KEYS.SYY_MB]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SYY_DRUGSTROE,
    businessType: 'index',
    thirdBizType: 'MB',
  },
  // 上药云小病0元治 授权 上药云授权 partnerCode 统一
  [THIRD_PLATFORM_KEYS.SYY_XB]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SYY_DRUGSTROE,
    businessType: 'index',
    thirdBizType: 'XB',
  },
  [THIRD_PLATFORM_KEYS.MB_NEW]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SYY_DRUGSTROE,
    businessType: 'index',
    thirdBizType: 'MB_NEW',
  },
  // 壹点灵心理倾诉权益 授权
  [THIRD_PLATFORM_KEYS.YDL_MENTALRELEASE]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.YDL_MENTALRELEASE,
    businessType: 'heartTalk',
  },

  // 首页 壹点灵 心理测评 授权 THIRD_PARTNER_AUTH_CONFIG.YDL_HEARTASSESS
  [`${THIRD_PLATFORM_RESOURCECODE.YDL_MENTALRELEASE}_HEARTASSESS`]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.YDL_MENTALRELEASE,
    businessType: 'heartAssess',
  },

  [THIRD_PLATFORM_KEYS.GJSC]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.GJSC,
    businessType: 'index',
  },
  [THIRD_PLATFORM_KEYS.ZA_MALL]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.ZA_MALL,
    businessType: 'goodsDetail',
  },
  // 善诊
  [THIRD_PLATFORM_KEYS.SZ]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SZ,
    businessType: 'index',
  },
  // 每年
  [THIRD_PLATFORM_KEYS.MNTJ]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.MNTJ,
    businessType: 'index',
  },
  // 洁众
  [THIRD_PLATFORM_KEYS.JZ_JY]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.JZ_JY,
    businessType: 'customPartner',
  }, // 桑果
  [THIRD_PLATFORM_KEYS.SANGGUO]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.SANGGUO,
    businessType: 'index',
  },
  [THIRD_PLATFORM_KEYS.YIYH]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.YIYH,
    businessType: 'index',
  },
  [THIRD_PLATFORM_KEYS.LEYA]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.LEYA,
    businessType: 'index',
  },

  [THIRD_PLATFORM_KEYS.CHONGTAI]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.CHONGTAI,
    businessType: 'index',
  },

  [THIRD_PLATFORM_KEYS.HY_MALL_DEPOSIT]: {
    partnerCode: THIRD_PLATFORM_RESOURCECODE.HY_MALL,
    businessType: 'cxDeposit',
  },
};

/* 第三方对接的小程序来源标识 统一管理*/
export const THIRD_RESOURCE_APPLET_CODE: thirdPlatformOption = {
  ZABX: 'ZABX', // 众安保险小程序
  ZABXCX: 'ZABXCX', // 众安保小程序
};

export const zajkAppid = 'wxbac45cc1588a5a75'; // 众安健康小程序appid
export const ownAppid = 'wx3c564538ea8e3905'; // 众安健康小程序appid

/** 互医支付宝小程序appid */
export const hospitalAlipayAppId = '2021002124617095';

/** 方伞支付宝小程序appid */
export const zaFsHealthAlipayAppId = '2021004112619209';

export const zajkChannelResourceCode = ['JKXSSY2021YYLB', 'JKXSSY2021TZCP']; // 众安健康小程序appid

// 问诊 + 心理咨询咨询 问诊流程共用一套，相关页面静态内容映射
export const INQUIRY_MENTALCONSULT_STATIC = {
  default: {
    baseTxt: '问诊',
    receiptTypeTxt: '问诊单',
    illnessDescTxt: '问诊症状',
    reportIllnessDescTxt: '主诉',
    conclusionDescTxt: '初步诊断',
    continueButtonTxt: '继续问诊',
    detailButtonTxt: '查看病历',
    cancelButtonTxt: '取消问诊',
    receiptPeople: '就诊人',
  },
  mentalConsult: {
    baseTxt: '咨询',
    receiptTypeTxt: '咨询单',
    illnessDescTxt: '咨询问题',
    reportIllnessDescTxt: '咨询问题',
    conclusionDescTxt: '咨询结论',
    detailButtonTxt: '查看详情',
    continueButtonTxt: '继续咨询',
    cancelButtonTxt: '取消咨询',
    receiptPeople: '咨询人',
  },
};

/** 高德地图 */
export const AMapUrl = 'https://webapi.amap.com/loader.js';

/** 保险类型 */
export enum PolicyType {
  /** 团险 */
  GROUP = 'G',
  /** 个险 */
  INDIVIDUAL = 'I',
}

/** 发票抬头类型 */
export enum InvoiceTitleType {
  /** 个人 */
  PERSONAL = '1',
  /** 单位 */
  COMPANY = '2',
}

/** 支付方式 */
export enum CashierPayMethod {
  /** 最福利支付 */
  ZUIFULI_PAY = 10,
  /** 混合支付 */
  MIXED_PAY = 11,
  /** 众安收银台 */
  Cash_PAY = 4,
}

/** 需要屏蔽的渠道资源码 */
export const BLACKLIST_CHANNEL_RESOURCE_CODE = ['BBQD'];

/** 判断是否需要屏蔽的渠道资源码 */
export const isInBlackListChannelResourceCode = (channelResourceCode = '') =>
  BLACKLIST_CHANNEL_RESOURCE_CODE.includes(channelResourceCode || getChannelResourceCode() || '');
